// @flow
import React from 'react';
import styled from 'styled-components';


import apple_app_store from '../../assets/images/App-Store-Button@2x.png';
import google_play_store from '../../assets/images/Google-Play-Button@2x.png';
import colors from '../../assets/css/colors';

import { ButtonPrimary } from '../';

const Wrapper = styled.div`
	width: calc(100% - 20px);
	margin: 20px auto;
	position: relative;
	background-color: #fff;
	box-sizing: border-box;
	padding: 20px 20px 40px;
	text-align: center;

	a img {
		width: 130px;
	}

	p {
		font-size: 18px;
		line-height: 1.4;
		color: ${colors.darkGrey};
		max-width: 13.22em;
		position: relative;
		margin-right: auto;
		margin-left: auto;
	}

	h4 {
		color: ${colors.nrlDarkGreen};
		font-size: 22px;
		line-height: 1.45;
		margin: 0 0 1em;
		font-weight: bold;
	}
`;

const Links = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 24px 0;
`;

const StyledButtonPrimary = styled(ButtonPrimary)`
	width: 200px;
	position: relative;
	margin: 0 auto;
`;

type Props = {
	page_name?: string,
};

const CURRENT_YEAR = process.env.REACT_APP_CURRENT_YEAR ;
export const GoToApp = ({ page_name = '' }: Props) => (
	<Wrapper>
		<h4>
			{page_name}
		</h4>

		<p>
			Draft ordering can be undertaken in desktop and app versions.
			{CURRENT_YEAR} apps are due in store in late January / early Feb
		</p>
		<Links>
			<a
				href="https://itunes.apple.com/au/app/nrl-fantasy/id796543693?mt=8"
				target="_blank"
				rel="noopener noreferrer"
				title="Apple App Store"
			>
				<img src={apple_app_store} alt="Apple App Store"/>
			</a>
			<a
				href="https://play.google.com/store/apps/details?id=com.fanhubmedia.NRLFantasy&hl=en_AU" // eslint-disable-line
				target="_blank"
				rel="noopener noreferrer"
				title="Google Play Store"
			>
				<img src={google_play_store} alt="Google Play Store"/>
			</a>
		</Links>

		<StyledButtonPrimary
			onClick={() => window.history.back()}
		>
			Go back
		</StyledButtonPrimary>
	</Wrapper>
);

export default GoToApp;


// WEBPACK FOOTER //
// ./src/components/GoToApp/index.js